import { Component, Input } from '@angular/core';
import { Settings } from '../models/Settings';

@Component({
    selector: 'pi-under-construction',
    templateUrl: './under-construction.component.html',
    styleUrls: ['./under-construction.component.scss'],
    standalone: false
})
export class UnderConstructionComponent  {

  @Input() settings: Settings;

}
